import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/data';

export default function FeaturedContent() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500">编辑团队为您精心挑选的优质内容</p>
          </div>
          <Link
            to="/category/dianying"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {featuredArticles.map((article) => (
            <article key={article.id} className="bg-white rounded-lg overflow-hidden group cursor-pointer">
              <Link to={`/article/${article.id}`}>
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
              </Link>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <Link
                    to={`/category/${article.categorySlug}`}
                    className="px-2 py-0.5 text-xs font-medium rounded-full bg-primary-100 text-primary-700 whitespace-nowrap cursor-pointer"
                  >
                    {article.category}
                  </Link>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
                <Link to={`/article/${article.id}`}>
                  <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                    {article.title}
                  </h3>
                </Link>
                <p className="text-sm text-foreground-500 line-clamp-2 mb-3">{article.excerpt}</p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-1.5 text-xs text-foreground-400">
                    <i className="ri-user-line"></i>
                    <span>{article.author}</span>
                  </div>
                  <div className="flex items-center gap-1.5 text-xs text-foreground-400">
                    <i className="ri-eye-line"></i>
                    <span>{article.views.toLocaleString()}</span>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}